import React from "react";
import "./CrewPilotNavRow.css";

/**
 * Shared compact navigation-row family for screens whose primary purpose is
 * "go to another screen" (More, Settings) — see docs/engineering for the
 * card-vs-row rule: dashboard/status information stays in cards, pure
 * navigation destinations use these rows.
 */
export function CrewPilotNavSectionHeader({ children }) {
  return <div className="cp-nav-section-header">{children}</div>;
}

export function CrewPilotNavList({ children }) {
  return <div className="cp-nav-list">{children}</div>;
}

export function CrewPilotNavRow({
  icon,
  title,
  subtitle,
  trailingText,
  onClick,
  disabled = false,
}) {
  return (
    <button
      type="button"
      className="cp-nav-row"
      onClick={onClick}
      disabled={disabled}
    >
      {icon != null ? <span className="cp-nav-row-icon">{icon}</span> : null}
      <span className="cp-nav-row-text">
        <span className="cp-nav-row-title">{title}</span>
        {subtitle ? <span className="cp-nav-row-subtitle">{subtitle}</span> : null}
      </span>
      {trailingText ? (
        <span className="cp-nav-row-trailing">{trailingText}</span>
      ) : null}
      <span className="cp-nav-row-chevron" aria-hidden="true">
        ›
      </span>
    </button>
  );
}
